import type { ActionFunctionArgs } from '~/types/route-args';
import { logout } from '@modules/user/api/logout.server';

export type UserLogoutAction = typeof action;

export const USER_LOGOUT_API_ROUTE = '/remix-api/user/logout';

export const action = (args: ActionFunctionArgs) => {
    return logout(args);
};
